import React from "react";
import classes from "./BackgroundEffects.module.css";

const BackgroundEffects = ({ variant = "default" }) => {
  return (
    <div className={`${classes.BackgroundEffects} ${classes[variant]}`}>
      <div className={classes.Grid}></div>
      <div className={classes.GlowOrb1}></div>
      <div className={classes.GlowOrb2}></div>
    </div>
  );
};

export default BackgroundEffects;
